import { Homecontainer } from 'src/containers/Home/Home';

export const Home = () => <Homecontainer />;
